import { render, staticRenderFns } from "./ConfirmData.vue?vue&type=template&id=faf74522&scoped=true&"
import script from "./ConfirmData.vue?vue&type=script&lang=js&"
export * from "./ConfirmData.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmData.vue?vue&type=style&index=0&id=faf74522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf74522",
  null
  
)

export default component.exports